/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface ButtonState {
  text: string;
  disabled?: boolean;
  icon?: string;
  showReset?: boolean;
  showGenerateTemplate?: boolean;
  successBtn?: boolean;
}

export interface RecordCount {
  created: number;
  deleted: number;
  ignored: number;
  updated: number;
}

interface SummaryItem extends RecordCount {
  name: string;
  rows: number;
}

/* eslint-disable camelcase */
export interface DirtySummaryItem extends SummaryItem {
  block_errors: string[];
  block_warnings: string[];
  row_errors: string[];
  row_warnings: string[];
}
/* eslint-enable camelcase */

export interface CleanSummaryItem extends SummaryItem {
  errors: string[];
  warnings: string[];
}

export enum State {
  Select = 'select',
  Analysing = 'analysing',
  Import = 'import',
  ImportHasErrors = 'importHasErrors',
  ClipboardImportHasErrors = 'clipboardImportHasErrors',
  Importing = 'importing',
  ClipboardImport = 'clipboardImport',
  DataPreview = 'dataPreview',
}

export interface DropdownOption {
  id: string;
  label: string;
  displayName?: string;
  mandatory?: boolean;
  isMapping?: boolean;
  isCustomAttribute?: boolean;
  $isDisabled?: boolean;
}

export interface Column {
  key: string;
  label?: string;
  mandatory?: boolean;
  presenter?: string;
  editable?: boolean;
  sortable?: boolean;
  activeAttribute?: DropdownOption;
}

export interface DataRow {
  id: number;
}

export const ERROR_IMPORTING_MULTIPLE_OBJECTS =
  'Import of multiple object types not supported. Please separate imports by object type.';
export const ERROR_MAX_ROW_LIMIT = 'More than 1000 rows not supported. Please split into multiple imports.';
export const ERROR_NO_DATA = 'Not data to import!';
export const ERROR_OBJECT_TYPE_NOT_SELECTED =
  'Object type not selected. Please indicate object type in the Select Object Type dropdown.';
export const ERROR_ATTRIBUTES_NOT_SELECTED =
  'Column header not selected. Please ensure all columns headers are assigned a designated attribute/mapping.';
